<div class="show-map-items-button">
    <ui-map-button>
        <ui-icon
            aria-hidden
            [icon]="'mobile-mode-list'"
        />
    </ui-map-button>
</div>
